import { render, staticRenderFns } from "./PurchaseOrderCatalog.vue?vue&type=template&id=06bc9bda"
import script from "./PurchaseOrderCatalog.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderCatalog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports